import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'primeicons/primeicons.css' 
import 'quill/dist/quill.snow.css'
// import "/public/fontawesome/css/all.min.css"
import '@fortawesome/fontawesome-free/css/all.css'

// Import ModuleRegistry and required AG Grid modules
import { 
            ModuleRegistry
        ,ClientSideRowModelModule 
        ,PaginationModule 
        ,ValidationModule
        ,TextFilterModule     
        ,NumberFilterModule
        } from 'ag-grid-community';
import moment from 'moment'
import 'moment/dist/locale/id'

// Register all modules AG Grid needs
ModuleRegistry.registerModules([
                ClientSideRowModelModule
            , PaginationModule
            , ValidationModule
            , TextFilterModule
            , NumberFilterModule                
]);

moment.locale('id')

const app = createApp(App)
app.use(router)
app.mount('#app')